<template>
  <v-snackbar

    v-if="snackbar"
    v-model="snackbar"
    :timeout="timeout"
    class="custom-snackbar"
    top
    multi-line
    color="white"
  >
    <div
      class="snackbar-icon"
      :style="{backgroundColor: type === 'error' ? 'red' : ''}"
    >
      <v-icon
        v-if="type=='error'"
        color="white"
        size="22px"
      >
        close
      </v-icon>
      <v-icon
        v-else
        color="white"
        size="22px"
      >
        check
      </v-icon>
    </div>

    {{ text }}
    <v-btn
      color="indigo"
      text
      class="snackbar-btn"
      @click="snackbar = false"
    >
      <v-icon
        class="snackbar-btn-icon  "
        color="white"
        size="14px"
      >
        close
      </v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Notification',
  data() {
    return {
      type: '',
      snackbar: false,
      text: '',
      timeout: 4000,
    };
  },
  created() {
    this.$bus.on(this.$events.SHOW_SNACKBAR, this.show);
  },
  methods: {
    show(type, text) {
      this.text = text;
      this.type = type;

      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/static/css/Variables.scss';

.custom-snackbar {
  .v-snack__wrapper {
    .v-snack__content{
      padding: 0;
      min-height: 42px;
      color: $grey69 !important;

      .snackbar-icon {
        height: 42px;
        width: 42px;
        line-height: 42px;
        background-color: #659455;
        text-align: center;
        margin: 0px 10px 0 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      .snackbar-btn {
        margin: 0 !important;
        .snackbar-btn-icon{
          color: $grey20 !important;
          > * {
            min-width: 30px !important;
            padding:0px;
          }
        }
      }
    }
  }
}

</style>
